var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"add-question-by-product-group-step"},[_c('i-steps',{attrs:{"current":_vm.current}},[_c('i-step',{attrs:{"title":"筛选试题"}}),_c('i-step',{attrs:{"title":"添加试题"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }